import { Modal } from "rsuite";
import { images } from "../../../assets";
import { getOfferPdf } from "../../../redux/offer";
import { useDispatch } from "react-redux";
import FileSaver from "file-saver";

import garageCart from "../../../redux/garageCart";
import Checkmark from "react-typescript-checkmark";

const OfferText = ({
  visible,
  offerId,
  handleClose,
}: {
  visible: boolean;
  offerId?: string;
  handleClose: () => void;
}) => {
  const dispatch = useDispatch();
  const handlePrint = () => {
    dispatch(
      getOfferPdf({
        payload: {
          onSuccess: (message, payload) => {
            window.open(payload, "_blank");
          },
          onError: (message) => {},
        },
        url: "api/offer/getpdfbyid/" + offerId,
      })
    );
  };

  const save = () => {
    dispatch(
      getOfferPdf({
        payload: {
          onSuccess: (message, payload) => {
            FileSaver.saveAs(payload, "teklif.pdf");
          },
          onError: (message) => {},
        },
        url: "api/offer/getpdfbyid/" + offerId,
      })
    );
  };

  return (
    <div>
      <Modal
        className="offer-end-modal"
        open={visible}
        size="xs"
        onClose={() => {
          dispatch(garageCart.actions.clearGarage());
          setTimeout(() => {
            window.location.replace("/");
          }, 1000);
          return handleClose();
        }}
      >
        <Modal.Header></Modal.Header>
        <div>
          <Modal.Body className="modal-body" style={{ padding: "10px 20px" }}>
            <div style={{ marginBlock: 10 }}>
              <Checkmark
                backgroundColor="rgb(255, 68, 54)"
                animationDuration={0.8}
                explosion={1.2}
              />
            </div>
            <div style={{ textAlign: "center" }} className="Modaltext">
              Oluşturduğunuz kiralama teklifi bize ulaştı. Size de bir kopyasını
              mail olarak ilettik. Satış uzmanlarımız en kısa sürede sizinle
              iletişime geçecektir.
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBlock: 20,
              }}
            >
              <img
                src={images.save}
                alt=""
                className="offer-img"
                style={{ marginInlineEnd: 15 }}
                onClick={save}
              />
              <img
                src={images.print}
                alt=""
                className="offer-img"
                onClick={handlePrint}
              />
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </div>
  );
};
export default OfferText;
